<mat-card>
  <mat-card-content>
    <mat-card-header *ngIf="!widget.meta.hideTitle">
      <mat-card-title
        *ngIf="!changeTitle; else editTitleWidget"
        [matTooltip]="'dashboard.operational.widgets.doubleClickToEditTitle' | t"
        matTooltipPosition="above"
        (dblclick)="editTitle()"
        class="editTitle"
        >{{ widget.name }}
        <sn-icon size="xs">edit</sn-icon>
      </mat-card-title>
      <button
        mat-icon-button
        *ngIf="canChange"
        icon="swap_horiz"
        [matTooltip]="'dashboard.operational.widgets.changeUrl' | t"
        matTooltipPosition="before"
        (click)="toogleChangeUrl()"
      >
        <mat-icon>swap_horiz</mat-icon>
      </button>
    </mat-card-header>
    <ng-container *ngIf="!widget.meta.embedUrl || changeUrl">
      <form [formGroup]="form" (ngSubmit)="submitForm()" class="youtube-form">
        <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
        <div class="fs-text-right">
          <button mat-button color="success" type="submit" [disabled]="form.invalid || !canChange">
            {{ 'common.send' | t }}
          </button>
          <button
            mat-button
            *ngIf="changeUrl"
            color="danger"
            type="button"
            (click)="toogleChangeUrl()"
          >
            {{ 'common.cancel' | t }}
          </button>
        </div>
      </form>
    </ng-container>
    <ng-container *ngIf="widget.meta.embedUrl && !changeUrl">
      <iframe
        class="embed-iframe"
        [src]="url"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </ng-container>
  </mat-card-content>
</mat-card>
<ng-template #editTitleWidget>
  <sn-form-edit-title
    [widget]="widget"
    [viewId]="viewId"
    (title)="setTitle($event)"
    (updateTitle)="setUpdateTitle($event)"
  ></sn-form-edit-title>
</ng-template>
